module.exports = __webpack_public_path__ + "img/27.bf88e5ac.png";